import React from 'react';
import './styles/index.css';
import App from './App';
import { createRoot } from 'react-dom/client';

// Disable console logs in production
if (process.env.REACT_APP_NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  // Keep console.error for critical errors
}

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>);


// // Register the service worker
// if ('serviceWorker' in navigator) {
//   console.log('Registering service worker...');
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js').then((registration) => {
//       if (registration.active) {
//         registration.active.postMessage({
//           type: 'INIT',
//           payload: {
//             version: process.env.REACT_APP_VERSION,
//           },
//         });
//       } else if (registration.installing) {
//         registration.installing.postMessage({
//           type: 'INIT',
//           payload: {
//             version: process.env.REACT_APP_VERSION,
//           },
//         });
//       } else if (registration.waiting) {
//         registration.waiting.postMessage({
//           type: 'INIT',
//           payload: {
//             version: process.env.REACT_APP_VERSION,
//           },
//         });
//       }
//     });
//   }
//   )
// }